export const findObject = ({
    data = [],
    value,
    property, 
    field,
}) => {
    if (!data.length) return;
    return data?.find((item) => item[property] === value)?.[field] ?? "";
};